module.exports = __webpack_public_path__ + "img/icon-file.e3a0d3ff.svg";